// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container utama untuk Maintenance - Paksa ke tengah */
.maint-wrapper {
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center; /* Center menegak */
    align-items: center;      /* Center melintang */
    width: 100%;
    min-height: 50vh;        /* Beri ketinggian minimum supaya boleh duduk tengah */
    box-sizing: border-box;
}

.maint-title {
    color: white;
    font-size: 1.5rem;
    text-align: center;
    font-family: 'GlitchGoblin', sans-serif;
    font-weight: 600;
    
}

/* Card untuk layout */
.maint-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    border: 1px solid #eaeaea;
    width: 100%;
    max-width: 400px;
    text-align: center;
}

.maint-status-text {
    font-size: 1.1rem;
    margin-bottom: 25px;
    color: #555;
}

/* Style Butang */
.maint-btn {
    width: 100%;
    padding: 14px;
    font-size: 16px;
    font-weight: 600;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    color: #fff;
    display: block; /* Pastikan dia block element */
}

.maint-btn-on { background-color: #28a745; }
.maint-btn-on:hover { background-color: #218838; }

.maint-btn-off { background-color: #dc3545; }
.maint-btn-off:hover { background-color: #c82333; }

.maint-btn:disabled {
    background-color: #b0b0b0;
    cursor: not-allowed;
    opacity: 0.7;
}

/* Responsif untuk Mobile */
@media (max-width: 480px) {
    .maint-card {
        width: 90%;
        padding: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/Maintenance.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,mBAAmB;IAC5C,mBAAmB,OAAO,qBAAqB;IAC/C,WAAW;IACX,gBAAgB,SAAS,sDAAsD;IAC/E,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,uCAAuC;IACvC,gBAAgB;;AAEpB;;AAEA,sBAAsB;AACtB;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,0CAA0C;IAC1C,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;AACf;;AAEA,iBAAiB;AACjB;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,cAAc,EAAE,+BAA+B;AACnD;;AAEA,gBAAgB,yBAAyB,EAAE;AAC3C,sBAAsB,yBAAyB,EAAE;;AAEjD,iBAAiB,yBAAyB,EAAE;AAC5C,uBAAuB,yBAAyB,EAAE;;AAElD;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA,2BAA2B;AAC3B;IACI;QACI,UAAU;QACV,aAAa;IACjB;AACJ","sourcesContent":["/* Container utama untuk Maintenance - Paksa ke tengah */\n.maint-wrapper {\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center; /* Center menegak */\n    align-items: center;      /* Center melintang */\n    width: 100%;\n    min-height: 50vh;        /* Beri ketinggian minimum supaya boleh duduk tengah */\n    box-sizing: border-box;\n}\n\n.maint-title {\n    color: white;\n    font-size: 1.5rem;\n    text-align: center;\n    font-family: 'GlitchGoblin', sans-serif;\n    font-weight: 600;\n    \n}\n\n/* Card untuk layout */\n.maint-card {\n    background: #ffffff;\n    border-radius: 12px;\n    padding: 30px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n    border: 1px solid #eaeaea;\n    width: 100%;\n    max-width: 400px;\n    text-align: center;\n}\n\n.maint-status-text {\n    font-size: 1.1rem;\n    margin-bottom: 25px;\n    color: #555;\n}\n\n/* Style Butang */\n.maint-btn {\n    width: 100%;\n    padding: 14px;\n    font-size: 16px;\n    font-weight: 600;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    color: #fff;\n    display: block; /* Pastikan dia block element */\n}\n\n.maint-btn-on { background-color: #28a745; }\n.maint-btn-on:hover { background-color: #218838; }\n\n.maint-btn-off { background-color: #dc3545; }\n.maint-btn-off:hover { background-color: #c82333; }\n\n.maint-btn:disabled {\n    background-color: #b0b0b0;\n    cursor: not-allowed;\n    opacity: 0.7;\n}\n\n/* Responsif untuk Mobile */\n@media (max-width: 480px) {\n    .maint-card {\n        width: 90%;\n        padding: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
